import { render, staticRenderFns } from "./EligiblePhysician.vue?vue&type=template&id=0ff2e73a"
import script from "./EligiblePhysician.vue?vue&type=script&lang=js"
export * from "./EligiblePhysician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports